import React from 'react';
import 'aframe';
import 'aframe-particle-system-component';
import 'aframe-touch-look-controls';
import 'aframe-mouse-cursor-component';
import { Entity, Scene, Cursor, Camera } from 'aframe-react';
import * as THREE from 'three';

import Circulito from './../../../UI/viewer/circulito.png';
import CirculitoWhite from './../../../UI/viewer/circulitoWhite.png';
import CiruclitoIndividual from './../../../UI/viewer/circulitoIndividual.png';
import CiruclitoIndividualAlt from './../../../UI/viewer/circulitoIndividualAlt.png';
import test from './../../../UI/viewer/Group_955-2.svg';
import transparent from './../../../UI/viewer/viewer/transparent.png';

import { recorridoData as RData } from '../../../data/recorrido.data';

class Viewer360 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			zoom: this.props.isMobile ? 110 : 64,
			zoomValue: 0,
			isTouchScreen: false,
			fade: false,
			opacity: 1,
			planeOpacity: -1,
			createBullets: true,
			currentCameraRotation: '0 90 0',
			currentName: '',
		};
	}

	/*componentDidMount() {
		var filling = false;
		setInterval(() => {
			if (this.state.opacity - 0.25 / 3 <= 1 && this.state.opacity - 0.25 / 3 >= 0.5 && !filling) {
				this.setState(
					{
						opacity: this.state.opacity - 0.25 / 3,
					},
					() => {
						if (this.state.opacity - 0.25 / 3 < 0.5) {
							filling = true;
						}
					}
				);
			} else if (this.state.opacity + 0.25 / 3 >= 0.5 && this.state.opacity + 0.25 / 3 <= 1 && filling) {
				this.setState(
					{
						opacity: this.state.opacity + 0.25 / 3,
					},
					() => {
						if (this.state.opacity + 0.25 / 3 > 1) {
							filling = false;
						}
					}
				);
			}
		}, 125);
		if (document.querySelector('a-camera') && document.querySelector('a-camera').components && document.querySelector('a-camera').components['look-controls'].yawObject) {
			document.querySelector('a-camera').components['look-controls'].yawObject.rotation.y = 1.6;
		}
	}*/

	handleZoom = (event) => {
		var rotation = document.querySelector('a-scene').camera.el.object3D;

		var value = event.deltaY < 0 ? -1.5 : 1.5;
		this.setState(
			{
				zoomValue: this.state.zoomValue + value,
			},
			() => {
				this.state.zoomValue < -30
					? this.setState({
							zoomValue: -30,
					  })
					: this.state.zoomValue > 10
					? this.setState({
							zoomValue: 10,
					  })
					: this.setState({
							zoom: this.state.zoom + value,
					  });
			}
		);
	};

	handleTouchScreen = (event) => {
		this.setState({
			isTouchScreen: true,
		});
	};

	handleMouse = () => {
		this.setState({
			isTouchScreen: false,
		});
	};

	componentDidUpdate = (prevProps) => {
		if (prevProps.currentScene.Image !== this.props.currentScene.Image) {
			this.setState(
				{
					fade: true,
					createBullets: false,
				},
				() => {
					new Promise((resolve, reject) => {
						const img = new Image();
						img.src = this.props.currentScene.Image;
						img.onload = (event) => {
							setTimeout(() => {
								if (this.props.isMobile && document.querySelector('a-camera').components['touch-look-controls']) {
									document.querySelector('a-camera').components['touch-look-controls'].yawObject.rotation.y = 0;
									document.querySelector('a-camera').components['touch-look-controls'].pitchObject.rotation.x = -0.2;
								} else {
									document.querySelector('a-camera').components['look-controls'].yawObject.rotation.y = 0;
									document.querySelector('a-camera').components['look-controls'].pitchObject.rotation.x = -0.2;
								}
								this.setState(
									{
										fade: false,
										createBullets: true,
									},
									() => {
										if (!this.props.renderFromMenu) {
											this.props.handleChangePano(this.state.currentName, true);
										}
									}
								);
							}, 200);
						};
					});
				}
			);
		}
	};

	handleLoad = (payload) => {
		this.setState(
			{
				fade: true,
				createBullets: false,
				currentName: payload,
			},
			() => {
				new Promise((resolve, reject) => {
					const img = new Image();
					img.src = RData()[0][payload].Image;
					img.onload = (event) => {
						this.props.handleChangePano(payload, false);
					};
				});
			}
		);
	};

	handleCreateBullet = (payload) => {
		var bullets = payload.BulletsDesplazamiento;
		if (bullets && bullets.length > 0) {
			return bullets.map((bullets, index) => (
				<Entity
					key={index}
					geometry={{ primitive: 'circle', radius: this.props.isMobile ? this.state.opacity * 2 : this.state.opacity }}
					cursor-listener
					class="raycastable"
					className={this.state.createBullets ? 'raycastable fade-in' : 'raycastable fade-out'}
					position={bullets.Position}
					rotation={bullets.Rotation}
					transparent="true"
					scale={bullets.Scale}
					src={Circulito}
					material={{ color: '', transparent: true, src: Circulito, opacity: this.state.opacity }}
					events={{ click: () => this.handleLoad(bullets.goTo), mouseenter: () => {} }}
				/>
			));
		}
	};

	handleCreateBulletFamilia = (payload) => {
		var bullets = payload.Bullets;
		if (bullets && bullets.length > 0) {
			return bullets.map((bullets, index) => (
				<Entity
					key={index}
					geometry={{ primitive: 'circle', radius: this.props.isMobile ? this.state.opacity * 2 : this.state.opacity }}
					cursor-listener
					class="raycastable"
					className={this.state.createBullets ? 'raycastable fade-in' : 'raycastable fade-out'}
					position={bullets.Position}
					rotation={bullets.Rotation}
					transparent="true"
					scale={bullets.Scale}
					src={CiruclitoIndividual}
					material={{ color: '', transparent: true, src: CiruclitoIndividual, opacity: this.state.opacity }}
					events={{ click: () => this.handleLoad(bullets.goTo), mouseenter: () => {} }}
				/>
			));
		}
	};

	handleCreateBulletIndividual = (payload) => {
		var bullets = payload.BulletsIndividual;
		if (bullets && bullets.length > 0) {
			return bullets.map((bullets, index) => (
				<Entity
					key={index}
					geometry={{ primitive: 'circle', radius: this.props.isMobile ? this.state.opacity * 2 : this.state.opacity }}
					cursor-listener
					class="raycastable"
					className={this.state.createBullets ? 'raycastable fade-in' : 'raycastable fade-out'}
					position={bullets.Position}
					rotation={bullets.Rotation}
					transparent="true"
					scale={bullets.Scale}
					src={CiruclitoIndividual}
					material={{ color: '', transparent: true, src: CiruclitoIndividual, opacity: this.state.opacity }}
					events={{ click: () => this.handleLoad(bullets.goTo), mouseenter: () => {} }}
				/>
			));
		}
	};

	handleCreateBulletInfo = (payload) => {
		var bullets = payload.BulletsInfo;
		if (bullets && bullets.length >= 1) {
			return bullets.map((bullets, index) => (
				<Entity
					key={index}
					geometry={{ primitive: 'circle', radius: this.props.isMobile ? this.state.opacity * 2 : this.state.opacity }}
					cursor-listener
					class="raycastable"
					className={this.state.createBullets ? 'raycastable fade-in' : 'raycastable fade-out'}
					position={bullets.Position}
					rotation={bullets.Rotation}
					transparent="true"
					scale={bullets.Scale}
					src={CirculitoWhite}
					material={{ color: '', transparent: true, src: CirculitoWhite, side: 'double', opacity: this.state.opacity, shader: 'flat', blending: 'normal', fog: false }}
					events={{ click: () => this.props.handleOpenBullet(true, bullets.Image, bullets.Text) }}
				/>
			));
		}
	};

	handleCreateLabels = (payload) => {
		var bullets = payload.Labels;
		if (bullets && bullets.length >= 1) {
			return bullets.map((bullets, index) => (
				<Entity
					key={index}
					geometry="primitive: plane"
					cursor-listener
					class="raycastable"
					position={bullets.Position}
					rotation={bullets.Rotation}
					transparent="true"
					scale={bullets.Scale}
					src={bullets.Image}
					material={{ color: '', transparent: true, src: bullets.Image, side: 'double', opacity: this.state.planeOpacity === index ? 1 : 0 }}
					events={{
						click: () => {
							this.setState({ planeOpacity: -1 }, () => {
								this.props.handleChnagePano(bullets.goTo);
							});
						},
					}}
				/>
			));
		}
	};

	handlePlaneOpacity = (payload) => {
		this.setState({
			planeOpacity: payload,
		});
	};

	handleCreateLabelsPlanes = (payload) => {
		var bullets = payload.LabelsPlane;
		if (bullets && bullets.length >= 1) {
			return bullets.map((bullets, index) => (
				<Entity
					key={index}
					geometry="primitive: plane"
					cursor-listener
					class="raycastable"
					position={bullets.Position}
					rotation={bullets.Rotation}
					transparent="true"
					scale={bullets.Scale}
					src={bullets.Image}
					material={{ color: '', transparent: true, src: transparent, side: 'double', opacity: 0.5 }}
					events={{
						mouseenter: () => {
							this.handlePlaneOpacity(index);
						},
						mouseleave: () => {
							this.handlePlaneOpacity(-1);
						},
						click: () => {
							this.setState({ planeOpacity: -1 }, () => {
								this.props.handleChnagePano(bullets.goTo);
							});
						},
					}}
				/>
			));
		}
	};

	render() {
		console.log(this.props.familia);
		console.log(this.props.vehiculo);
		return (
			<React.Fragment>
				<div
					className={this.state.fade ? 'viewer-360' : 'viewer-360'}
					onWheel={(e) => {
						this.handleZoom(e);
					}}
					onTouchStart={(e) => {
						this.handleTouchScreen(e);
					}}>
					{
						<Scene cursor="rayOrigin: mouse; fuse: false" raycaster="objects: .raycastable" vr-mode-ui="enabled: false" device-orientation-permission-ui="enabled: false" 
						//data-value={this.props.familia} data-second={this.props.vehiculo === "" ? undefined : this.props.vehiculo} data-type={this.props.vehiculo === "" ? "MODELO" : "VERSION"}
						>
							<Entity ref={this.camera} id="cameraWrapper" rotation={this.props.currentScene.Rotation} >
								{!this.state.isTouchScreen ? (
									<a-camera
										fov={this.state.zoom}
										wasd-controls="adEnabled: false; enabled: false; wsEnabled: false"
										look-controls="reverseMouseDrag: true; reverseTouchDrag: true, enabled: false"
										aframe-injected=""
										data-aframe-inspector-original-camera=""
										magicWindowTrackingEnabled={false}
										device-orientation-permission-ui="enabled: false"
									/>
								) : (
									<a-camera
										fov={this.state.zoom}
										wasd-controls="adEnabled: false; enabled: false; wsEnabled: false"
										aframe-injected=""
										data-aframe-inspector-original-camera=""
										camera=""
										magicWindowTrackingEnabled={false}
										touch-look-controls="reverseMouseDrag: true; reverseTouchDrag: true"
										device-orientation-permission-ui="enabled: false"></a-camera>
								)}
							</Entity>
							<Entity primitive="a-sky" src={this.props.currentScene.Image} segments-height={100} segments-width={200} radius={200} />
							{this.state.createBullets ? this.handleCreateBullet(this.props.currentScene) : null}
							{this.state.createBullets ? this.handleCreateBulletFamilia(this.props.currentScene) : null}
							{this.state.createBullets ? this.handleCreateBulletIndividual(this.props.currentScene) : null}
							{this.state.createBullets ? this.handleCreateBulletInfo(this.props.currentScene) : null}
							{this.state.createBullets ? this.handleCreateLabels(this.props.currentScene) : null}
						</Scene>
					}
				</div>
				{
					<div
						className={this.state.fade ? 'loading-div fade-in' : 'loading-div fade-out'}
						style={{
							backgroundColor: 'rgba(0,0,0,0.6)',
							position: 'absolute',
							width: '100%',
							height: '100%',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%,-50%)',
						}}>
						<svg
							className="loader-circle"
							viewBox="0 0 150 150"
							xmlns="http://www.w3.org/2000/svg"
							style={{
								width: '20%',
								height: '20%',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%,-50%)',
							}}>
							<circle className="internal-circle" cx="75" cy="75" r="70"></circle>
						</svg>
						<svg
							className="loader-circle-over"
							viewBox="0 0 150 150"
							xmlns="http://www.w3.org/2000/svg"
							style={{
								width: '20%',
								height: '20%',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%,-50%)',
							}}>
							<circle className="internal-circle-over" cx="75" cy="75" r="70"></circle>
						</svg>
					</div>
				}
			</React.Fragment>
		);
	}
}

export default Viewer360;
